import { render, staticRenderFns } from "./EditCategories.vue?vue&type=template&id=a74c76f6"
import script from "./EditCategories.vue?vue&type=script&lang=js"
export * from "./EditCategories.vue?vue&type=script&lang=js"
import style0 from "./EditCategories.vue?vue&type=style&index=0&id=a74c76f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports